/**
 * Upload configuration, mirroring PlatformSettingKeys.cs — keep both in sync.
 *
 * Deliberately no sizes or extension lists here: those are host-configurable and fetched at
 * runtime (see hooks/useUploadPolicy), so changing a limit is a settings edit rather than a
 * release. Anything baked into this bundle would defeat that.
 */

/** Setting keys shared by the host defaults screen and the per-organisation override dialog. */
export const UPLOAD_SETTING_KEY = {
  DOCUMENT_MAX_MB: 'Uploads.DocumentMaxMb',
  DOCUMENT_EXTENSIONS: 'Uploads.DocumentExtensions',
  IMAGE_MAX_MB: 'Uploads.ImageMaxMb',
  IMAGE_EXTENSIONS: 'Uploads.ImageExtensions',
  URL_EXPIRY_MINUTES: 'Uploads.UrlExpiryMinutes',
};

/**
 * Which set of rules an attachment surface follows. Mirrors UploadKind on the server, and matches
 * the keys of the /api/Files/upload-policy response. ANY is the union, for surfaces that hold
 * either a scanned record or a photograph of one.
 */
export const UPLOAD_KIND = {
  DOCUMENT: 'document',
  IMAGE: 'image',
  ANY: 'any',
};
